<template>
  <div class="ipim-calculator panel">
    <b-collapse v-model="open" animation="slide">
      <template #trigger>
        <p
          class="panel-heading has-text-centered"
          :style="{
            'background-color': themeColor.bgColor,
            color: themeColor.color,
          }"
        >
          {{ title }}
        </p>
      </template>
      <div class="panel-block">
        <slot></slot>
      </div>
    </b-collapse>
  </div>
</template>
<script>
export default {
  // name: "CalculatorCard",
  props: ["title", "theme"],
  data() {
    return {
      open: false,
    };
  },
  computed: {
    themeColor() {
      if (this.theme === "macau") {
        return {
          bgColor: "#00775e",
          color: "white",
        };
      } else if (this.theme === "gbp") {
        return {
          bgColor: "rgba(46,110,182,0.9)",
          color: "white",
        };
      }
      return "";
    },
  },
};
</script>

<style lang="scss">
.ipim-calculator input {
  height: 2.5rem !important;
}
</style>
